<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">ANALISIS DE PRECIO UNITARIO ({{reference}})</span>
  <button mat-icon-button (click)="closeDialogDetallePartida()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey scrollable-content" style="height: 100% !important;">
  <mat-card-content style="height: 100%;">
    <div class="mat-elevation-z4 div-ajusted div-full-width">
      <form [formGroup]="departureDetailForm">
        <div class="row-flex" fxHide.xs fxHide.sm fxHide.md fxLayoutGap="20px">
          <div class="col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Referencia </mat-label>
              <input matInput formControlName="reference" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Fecha </mat-label>
              <input matInput formControlName="date" required>
            </mat-form-field>
          </div>
          <div class="col">
            <button mat-raised-button color="primary" [disabled]="statusPdf" class="margin-left-25px" (click)="verEspecificaciones(urlPdf)">
              <span class="text-icon-space">Ver PDF</span>
              </button>
              </div>
              <div class="col">
                <button mat-raised-button color="primary" [disabled]="statusMemo" class="margin-left-25px"
                  (click)="openMemoSpecification(specificationMemo)">
                  <span class="text-icon-space">Ver Memoria</span>
            </button>
          </div>
        </div>
        <div class="row-flex" fxHide.lg fxHide.xl fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column">
          <div class="col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Referencia </mat-label>
              <input matInput formControlName="reference" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Fecha </mat-label>
              <input matInput formControlName="date" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxHide.lg fxHide.xl>
          <div class="col">
            <button mat-raised-button color="primary" [disabled]="statusPdf" class="margin-bottom-15px" (click)="verEspecificaciones(urlPdf)">
              <span class="text-icon-space">Ver PDF</span>
              </button>
            </div>
            <div class="col">
                <button mat-raised-button color="primary" [disabled]="statusMemo" class="margin-bottom-15px"
                  (click)="openMemoSpecification(specificationMemo)">
                  <span class="text-icon-space">Ver Memoria</span>
            </button>
          </div>
        </div>
        <div class="espacio-div-20" fxHide.lg fxHide.xl></div>
        <div class="row-flex" fxLayout.xs="column">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Clasificación Partida </mat-label>
              <input matInput formControlName="clasification" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="20px">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Código </mat-label>
              <input matInput formControlName="code" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Unidad </mat-label>
              <input matInput formControlName="unity" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Cantidad </mat-label>
              <input matInput formControlName="quantity" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Rendimiento </mat-label>
              <input matInput formControlName="yield" class="input-align-right" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Descripción </mat-label>
              <textarea matInput formControlName="description" required></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Descripción Corta </mat-label>
              <input matInput formControlName="shortDescription" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Comentario </mat-label>
              <input matInput formControlName="commentary" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout.xs="column" fxLayoutGap="20px">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Agrupación </mat-label>
              <input matInput formControlName="group" required>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Condiciones </mat-label>
              <input matInput formControlName="conditions" required>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="oilCompany">
          <mat-label class="label-red">Factores de Ajustes para el Rendimiento</mat-label>
          <div class="div-border">
            <div class="row-flex" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Pérdida/Perm. </mat-label>
                  <input matInput formControlName="lossPermission" class="input-align-right">
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Dificultad </mat-label>
                  <input matInput formControlName="difficulty" class="input-align-right" >
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Imprevisto </mat-label>
                  <input matInput formControlName="unplanned" class="input-align-right" >
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label class="label-red">Factor de Ajuste </mat-label>
                  <input matInput class="input-align-right" value="{{ factorAjuste | number:'1.6':'es' }}"  [disabled]="true">
                </mat-form-field>
              </div>
            </div>
            <div class="row-flex" fxLayout.xs="column" fxLayoutGap="20px">
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Movilización </mat-label>
                  <input matInput formControlName="mobilization" class="input-align-right">
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Varios </mat-label>
                  <input matInput formControlName="other" class="input-align-right">
                </mat-form-field>
              </div>
              <div class="col">

              </div>
              <div class="col">
                <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label class="label-red">Rend. Ajustado </mat-label>
                  <input matInput class="input-align-right" value="{{ rendAjustado | number:'1.6':'es' }}" [disabled]="true">
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <h3 class="h3-shadow">1. MATERIALES ({{materialDetailList.length }})</h3>
        <div class="table-overflow-100">
          <table mat-table [dataSource]="dataSourceMaterial" class="mat-elevation-z8">
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> No. </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.materialPosition}} </td>
            </ng-container>
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.referenceMaterial}} </td>
            </ng-container>
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
              <td mat-cell *matCellDef="let element"> {{element.materialDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="unidad">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Und. </th>
              <td mat-cell *matCellDef="let element"> {{element.materialUnit}} </td>
            </ng-container>
            <ng-container matColumnDef="cantidad">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cantidad </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.materialQuantity | number:'1.4-4':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="desperdicio">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Desp. </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.wasteMaterial | number:'1.1-1':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="precio">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
              <td mat-cell *matCellDef="let element" align="right">
                <div *ngIf="element.idTypeMaterial === 2" class="cell-red">
                  {{element.priceMaterial | number:'1.2-2':'es'}}
                </div>
                <div *ngIf="element.idTypeMaterial === 1">
                  {{element.priceMaterial | number:'1.2-2':'es'}}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell class="right-align" style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Total
                Material </th>
              <td mat-cell align="right" *matCellDef="let element"> {{element.materialTotalPrice | number:'1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.updateDate | date:'dd/MM/yyyy'}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterial" class="mat-header-medium"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterial;"></tr>
          </table>
        </div>
        <div class="table-overflow-100">
          <table class="mat-table">
            <tbody>
              <tr>
                <th class="mat-header-cell" style="border-bottom: none;border-top: none;border-left: none;border-right: none;text-align: right !important;">
                  <section>
                    <mat-checkbox [disabled]="true" formControlName="dividirMaterial">Dividir Mat/Rendi.</mat-checkbox>
                  </section>
                </th>
                <td class="mat-cell" style="border-left: none;border-right: none;"></td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-left: none;border-top: none;border-right: none;text-align: right !important;">
                  Total Materiales:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ totalMateriales |
                  number:'1.2-2':'es'}}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  % de Incidencia:</th>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ porcIncidenciasMateriales | number:'1.4-4':'es' }}</td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  Costo Unitario Materiales:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ costoUnicoMateriales |
                  number:'1.2-2':'es' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <h3 class="h3-shadow">2. EQUIPOS ({{equipmentDetailList.length }})</h3>
        <div class="table-overflow-100">
          <table mat-table [dataSource]="dataSourceEquipo" class="mat-elevation-z8">
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> No. </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.equipmentPosition}} </td>
            </ng-container>
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.equipmentReference}} </td>
            </ng-container>
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
              <td mat-cell *matCellDef="let element"> {{element.equipmentDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="cantidad">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cantidad </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.quantityEquipment | number: '1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="desperdicio">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> COP/Dep. </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.depreciationEquipment| number: '1.6':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="precio">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
              <td mat-cell *matCellDef="let element" align="right">
                <div *ngIf="element.idTypeEquipment === 2" class="cell-red">
                  {{element.priceEquipment | number:'1.2-2':'es'}}
                </div>
                <div *ngIf="element.idTypeEquipment === 1">
                  {{element.priceEquipment | number:'1.2-2':'es'}}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Total Equipo </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.equipmentTotalPrice | number: '1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.updateDate | date:'dd/MM/yyyy'}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos" class="mat-header-medium"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos;"></tr>
          </table>
        </div>
        <div class="table-overflow-100">
          <table class="mat-table">
            <tbody>
              <tr>
                <th class="mat-header-cell" style="border-bottom: none;border-top: none;border-left: none;border-right: none;text-align: right !important;"></th>
                <td class="mat-cell" style="border-left: none;border-right: none;"></td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-left: none;border-top: none;border-right: none;text-align: right !important;">
                  Total Equipos:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ totalEquipos |
                  number:'1.2-2':'es'}}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  % de Incidencia:</th>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ porcIncidenciasEquipos | number:'1.4-4':'es' }}</td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  Costo Unitario Equipos:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ costoUnicoEquipo |
                  number:'1.2-2':'es' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <h3 class="h3-shadow">3. MANO DE OBRA ({{laborDetailList.length }})</h3>
        <div class="table-overflow-100">
          <table mat-table [dataSource]="dataSourceManosObra" class="mat-elevation-z8">
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> No. </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.laborPosition}} </td>
            </ng-container>
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.laborReference}} </td>
            </ng-container>
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
              <td mat-cell *matCellDef="let element"> {{element.laborDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="cantidad">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cantidad </th>
              <td mat-cell *matCellDef="let element" align="right"> {{element.quantityLabor | number: '1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="jornal">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Jornal </th>
              <td mat-cell align="right" *matCellDef="let element">
                <div *ngIf="element.idTypeLabor === 2" class="cell-red">
                  {{element.jornalLabor | number:'1.2-2':'es'}}
                </div>
                <div *ngIf="element.idTypeLabor === 1">
                  {{element.jornalLabor | number:'1.2-2':'es'}}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="bono">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Bono </th>
              <td mat-cell align="right" *matCellDef="let element">
                <div *ngIf="element.idTypeLabor === 2" class="cell-red">
                  {{element.priceLabor | number:'1.2-2':'es'}}
                </div>
                <div *ngIf="element.idTypeLabor === 1">
                  {{element.priceLabor | number:'1.2-2':'es'}}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="totaljornal">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Total Jornal </th>
              <td mat-cell align="right" *matCellDef="let element"> {{element.laborTotalJornal | number: '1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="totalbono">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Total Bono </th>
              <td mat-cell align="right" *matCellDef="let element"> {{element.laborTotalBonus | number: '1.2-2':'es'}} </td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell style="width: 18%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
              <td mat-cell *matCellDef="let element" align="center"> {{element.updateDate | date:'dd/MM/yyyy'}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsManoObras" class="mat-header-medium"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsManoObras;"></tr>
          </table>
        </div>
        <div class="table-overflow-100">
          <table class="mat-table">
            <tbody>
              <tr>
                <th class="mat-header-cell label-black-bold" style="border-bottom: none;border-left: none;text-align: right !important;"
                  colspan="2">
                  Subtotal Mano de Obra:</th>
                <td class="mat-cell" style="width: 22%;text-align: right !important;">{{ totalBonoManoDeObra | number: '1.2-2':'es' }}</td>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ totalManoDeObra | number: '1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold" style="border: none !important;text-align: right !important;" colspan="2">
                  {{ porcPrestacionesManoDeObra }}% Prestaciones Sociales:</th>
                <td class="mat-cell" style="width: 22%;text-align: right !important;">0,00</td>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ prestManoDeObra | number: '1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold"
                  style="border: none !important;border-bottom: none;text-align: right !important;" colspan="2">
                  SubTotal + Prestaciones:</th>
                <td class="mat-cell" style="width: 22%;text-align: right !important;">{{ totalBonoManoDeObra | number: '1.2-2':'es' }}</td>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ prestManoDeObra + totalManoDeObra| number: '1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell" style="border-bottom: none;border-top: none;border-left: none;border-right: none;text-align: right !important;"></th>
                <td class="mat-cell" style="border-left: none;border-right: none;border-top: none;"></td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-left: none;border-top: none;border-right: none;text-align: right !important;">
                  Total General Mano de Obra:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ totalGeneralManoDeObra |
                  number:'1.2-2':'es' }}</td>
                <!-- <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ totalGeneralManoDeObra  }}</td> -->
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  % de Incidencia:</th>
                <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ porcIncidenciasManoDeObra | number:'1.4-4':'es' }}</td>
                <th class="mat-header-cell label-black-bold"
                  style="border-bottom: none;border-top: none;border-left: none;text-align: right !important;">
                  Costo Unitario Mano de Obra:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ costoUnicoManoDeObra |
                  number:'1.2-2':'es' }}</td>
                <!-- <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ costoUnicoManoDeObra }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <div class="mat-table table-overflow-100" style="text-align: right;align-items:right;">
          <table style="width: 70%; margin-left: 30%;">
            <tbody>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-red-bold" style="width: 30%;text-align: right !important;">Costo Directo SubTotal A:
                </th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ costoDirectoSubTotalA |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-black-bold" style="width: 30%;text-align: right !important;">{{
                  porcGastosAdministrativos | number:'1.2-2':'es' }}% Administración y Gastos
                  Generales:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ gastosGeneralesAdmin |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-red-bold" style="width: 30%;text-align: right !important;">SubTotal B:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ subTotalB |
                  number:'1.2-2':'es' }}</td>
                <!-- <td class="mat-cell" style="width: 18%;text-align: right !important;">{{ gastosGeneralesAdmin + costoDirectoSubTotalA }}</td> -->
              </tr>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-black-bold" style="width: 30%;text-align: right !important;">{{
                  porcUtilidadesImprevisto | number:'1.2-2':'es' }}% Utilidad e Imprevistos:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ utilidadesImprevisto |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-red-bold" style="width: 30%;text-align: right !important;">SubTotal C:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ subTotalC |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold" style="width: 40%;border: none !important;text-align: right !important;">
                  Horas laborales al día: </th>
                <td class="mat-cell" style="border: none !important;width: 10%;text-align: right !important;padding-right: 5%;">{{ workingHour | number:'1.2-2':'es' }}</td>
                <th class="mat-header-cell label-black-bold" style="width: 30%;text-align: right !important;">{{ porcFinanciamiento |
                  number:'1.2-2':'es' }}% Financiamientos:</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ financiamiento |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold" style="width: 40%;border: none !important;text-align: right !important;">
                  Horas Hombre x Día: </th>
                <td class="mat-cell" style="border: none !important;width: 10%;text-align: right !important;padding-right: 5%;">{{ workingHourDay | number:'1.2-2':'es' }}</td>
                <th class="mat-header-cell label-red-bold" style="width: 30%;text-align: right !important;">Precio Unitario sin
                  Impuestos:</th>
                <td class="mat-cell label-red-bold" style="width: 18%;text-align: right !important;">{{ precioUnitarioSinImpuesto |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold" style="border: none !important;text-align: right !important;">Horas Hombre
                  x Día / Rend.: </th>
                <td class="mat-cell" style="border: none !important;width: 10%;text-align: right !important;padding-right: 5%;">{{horasRendimiento | number:'1.3-3':'es'}}</td>
                <th class="mat-header-cell label-black-bold" style="width: 45%;text-align: right !important;">{{ porcImpuestoIva |
                  number:'1.2-2':'es' }}% Impuestos (I.V.A):</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ montoImpuestoIva |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell label-black-bold" style="border: none !important;text-align: right !important;">PU / (Horas
                  Hombres x Día / Rend.): </th>
                <td class="mat-cell" style="border: none !important;width: 10%;text-align: right !important;padding-right: 5%;">{{precioUnitarioHorasRend | number:'1.2-2':'es'}}</td>
                <th class="mat-header-cell label-black-bold" style="width: 45%;text-align: right !important;">{{ porcOtrosImpuestos |
                  number:'1.2-2':'es' }}% Otros Impuestos (I.V.A):</th>
                <td class="mat-cell label-black-bold" style="width: 18%;text-align: right !important;">{{ montoOtrosImpuestos |
                  number:'1.2-2':'es' }}</td>
              </tr>
              <tr>
                <th class="mat-header-cell" style="width: 40%;border: none !important;"></th>
                <td class="mat-cell" style="border: none !important;padding-right: 5%;"></td>
                <th class="mat-header-cell label-blue" style="width: 30%;text-align: right !important;">PRECIO UNITARIO:</th>
                <td class="mat-cell label-blue" style="width: 18%;text-align: right !important;">{{ precioUnitario | number:'1.2-2':'es'
                  }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  </mat-card-content>
  <mat-card-actions style="text-align: center;">
    <button mat-raised-button color="warn" (click)="verDetallePDF('open')" fxHide.xs fxHide.sm fxHide.md>
      <span class="text-icon-space">Imprimir</span>
      <mat-icon>print</mat-icon>
    </button>
    <button mat-raised-button color="primary" (click)="verDetallePDF('download')">
      <span class="text-icon-space">Descargar PDF</span>
      <mat-icon>file_download</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
